import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
    FormControlLabel,
    ListItemText,
} from "@mui/material";
import {
    CustomSelect,
} from "components/Input/Index.js";
import Button from "components/CustomButtons/Button";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { AddCircleOutline } from "@mui/icons-material";
import List from "@mui/material/List";
import uuid from "react-uuid";
import { makeStyles } from "@mui/styles";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import RuleLineCondition from "./RuleLineCondition";
import { granularityData, numbercomparatorData, dataTypeData } from "variables/lists/alerts";
import { getIndicators, getDictionnary, getMBMEquipments } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";

const searchStyle = makeStyles(advancedSearchStyle);

function RulesTab(props) {

    const { rule, handleRuleChange, granularity, setGranularity } = props;
    const appContext = useContext(AdvancedSearchContext);
    const { chartIdGroup, groupInfoListById } = appContext;

    const [indicatordata, setIndicatordata] = useState([]);
    const [fulldictionnarydata, setFulldictionnarydata] = useState([]);
    const [dictionnarydata, setDictionnarydata] = useState([]);
    const [dictionnarydataFiltered, setDictionnarydataFiltered] = useState([]);
    const [pointsdata, setPointsdata] = useState([]);
    const [dataType, setDataType] = useState('indic');

    const conditionAnd = 'Et';
    const conditionOr = 'Ou';

    useEffect(() => {
        fillIndicators(granularity, true);
        getFullDictionnary(granularity);
        getPointsData();
        checkDataType();
    }, []);

    const checkDataType = () => {
        let datatypetmp = '';
        if (rule && rule.and) {
            rule.and.map((condition) => {
                if ((condition.item && ('' + condition.item).startsWith('d')) || (condition.item2 && ('' + condition.item2).startsWith('d'))) {
                    datatypetmp = 'def';
                }
                else if ((condition.item && ('' + condition.item).startsWith('p')) || (condition.item2 && ('' + condition.item2).startsWith('p'))) {
                    datatypetmp = 'point';
                }
            });
        }
        if (!datatypetmp && rule && rule.or) {
            rule.or.map((condition) => {
                if ((condition.item && ('' + condition.item).startsWith('d')) || (condition.item2 && ('' + condition.item2).startsWith('d'))) {
                    datatypetmp = 'def';
                }
                else if ((condition.item && ('' + condition.item).startsWith('p')) || (condition.item2 && ('' + condition.item2).startsWith('p'))) {
                    datatypetmp = 'point';
                }
            });
        }
        if(!datatypetmp)
            datatypetmp = 'indic';
        setDataType(datatypetmp);
    };

    const fillIndicators = (gran, init) => {
        axios
            .get(
                getIndicators(chartIdGroup, "alerts", gran),
                {
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                    },
                }
            )
            .then((res) => {
                setIndicatordata(res.data.indicators || []);
                if (gran !== granularity) {
                    setGranularity(gran);
                    handleRuleChange({ and: [], or: [] });
                }
            })
            .catch(() => { });
    }


    const getFullDictionnary = (granularity) => {
        axios
            .get(
                getDictionnary(chartIdGroup, "available"),
                {
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                    },
                }
            )
            .then((res) => {
                setFulldictionnarydata(res.data);
                console.log(res.data, granularity);
                fillDictionnary(res.data, granularity);
            })
            .catch(() => { });
    }

    const getPointsData = () => {
        axios
            .get(getMBMEquipments(chartIdGroup, "false"), {
                headers: {
                    Authorization: `Bearer ${UserService.getToken()}`,
                },
            })
            .then((res) => {
                let points = res.data.points.map((point) => {
                    let newpoint = { id: 'p' + point.pointid, name: point.name + ' (' + groupInfoListById["" + point.groupid] + ')' };
                    return newpoint;
                });
                setPointsdata(points);
            });

    }


    const fillDictionnary = (dictionnary, gran) => {
        let filtered = dictionnary.filter((item) =>
            (item.hour && gran === '1h') || (item.day && gran === '1d'));
        let tmpdictionnarydata = filtered.map((item) => {
            return { id: 'd' + item.id, name: item.name };
        });
        setDictionnarydata(tmpdictionnarydata);
        console.log(tmpdictionnarydata, rule);
        fiterDictionnary(tmpdictionnarydata, rule);
    }

    const fiterDictionnary = (dictionnary, rule) => {
        let definition = '';
        if (rule && rule.and) {
            rule.and.map((condition) => {
                if (condition.item && ('' + condition.item).startsWith('d')) {
                    definition = condition.item;
                }
                else if (condition.item2 && ('' + condition.item2).startsWith('d')) {
                    definition = condition.item2;
                }
            });
        }
        if (!definition && rule && rule.or) {
            rule.or.map((condition) => {
                if (condition.item && ('' + condition.item).startsWith('d')) {
                    definition = condition.item;
                }
                else if (condition.item2 && ('' + condition.item2).startsWith('d')) {
                    definition = condition.item2;
                }
            });
        }
        let filtered = dictionnary;
        if(definition)
        {
            filtered = dictionnary.filter((item) =>
            (item.id === definition));
        }
        setDictionnarydataFiltered(filtered);
    }

    const handleGranularityChange = (event) => {
        if (event.target.value !== granularity) {
            fillIndicators(event.target.value, false);
            fillDictionnary(fulldictionnarydata, event.target.value);
        }
    }

    const handleDataTypeChange = (event) => {
        if (event.target.value !== dataType) {
            setDataType(event.target.value);
            handleRuleChange({ and: [], or: [] });
        }
    }

    const addingAndCondition = () => {
        const id = uuid();
        const obj = {
            "itemuuid": uuid(),
            "item2uuid": uuid(),
            "item": indicatordata[0]?.id,
            "item2": indicatordata[0]?.id,
            "comparator": numbercomparatorData[0].value,
            "value": '',
            "id": id,
            "defitem1": {},
            "defitem2": {},
        };
        let newRule = { ...rule };
        newRule.and.push(obj);
        handleRuleChange(newRule);
    }

    const removeAndCondition = (id) => {
        let newRule = { ...rule };
        const remove = newRule.and;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newRule.and = remove;
        handleRuleChange(newRule);
        fiterDictionnary(dictionnarydata, newRule);
    }

    const handleConditionChange = () => {
        let newRule = { ...rule };
        console.log(newRule);
        handleRuleChange(newRule);
        fiterDictionnary(dictionnarydata, newRule);
    }


    const addingOrCondition = () => {
        const id = uuid();
        const obj = {
            "itemuuid": uuid(),
            "item2uuid": uuid(),
            "item": indicatordata[0]?.id,
            "item2": indicatordata[0]?.id,
            "comparator": numbercomparatorData[0].value,
            "value": '',
            "id": id,
            "defitem1": {},
            "defitem2": {},
        };
        let newRule = { ...rule };
        newRule.or.push(obj);
        handleRuleChange(newRule);
    }

    const removeOrCondition = (id) => {
        let newRule = { ...rule };
        const remove = newRule.or;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newRule.or = remove;
        handleRuleChange(newRule);
        fiterDictionnary(dictionnarydata, newRule);
    }

    const classes = searchStyle();
    return (

        <div>
            <div>
                <CustomSelect
                    inputTitle={"Granularité de l'alerte"}
                    selectValue={granularity}
                    handleSelectValueChange={handleGranularityChange}
                    data={granularityData}
                />
            </div>
            <div>
                <CustomSelect
                    inputTitle={"Type de données"}
                    selectValue={dataType}
                    handleSelectValueChange={handleDataTypeChange}
                    data={dataTypeData}
                />
            </div>
            <GridContainer>
                <GridItem xs={12} sm={12}>
                    <List component={"nav"}>
                        <ListItemText className={classes.listItemText}> L'alerte doit remplir toutes ces conditions </ListItemText>
                        {
                            rule?.and?.map((condition) => {
                                return (<RuleLineCondition
                                    key={condition.id} id={condition.id}
                                    obj={condition}
                                    removeCondition={() => removeAndCondition(condition.id)}
                                    whichCondition={conditionAnd}
                                    indicatordata={indicatordata}
                                    dictionnarydata={dictionnarydataFiltered}
                                    pointsdata={(granularity === '1h' || granularity === '1d') ? pointsdata : []}
                                    handleConditionChange={handleConditionChange}
                                    granularity={granularity}
                                    dataType={dataType}
                                ></RuleLineCondition>);
                            })
                        }
                    </List>

                    <FormControlLabel
                        value="addCondition"
                        className={classes.formControlLabel}
                        control={
                            <Button
                                type="button" round
                                color="transparent"
                                justIcon size={"sm"}
                                onClick={addingAndCondition}
                            >
                                <AddCircleOutline> </AddCircleOutline>
                            </Button>
                        }
                        label=" Ajouter une condition "
                    />
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={12} sm={12}>
                    <List component={"nav"}>
                        <ListItemText className={classes.listItemText}> L'alerte doit remplir au moins une condition </ListItemText>
                        {
                            rule?.or?.map((condition) => {
                                return (<RuleLineCondition
                                    key={condition.id} id={condition.id}
                                    obj={condition}
                                    removeCondition={() => removeOrCondition(condition.id)}
                                    whichCondition={conditionOr}
                                    indicatordata={indicatordata}
                                    dictionnarydata={dictionnarydataFiltered}
                                    pointsdata={(granularity === '1h' || granularity === '1d') ? pointsdata : []}
                                    handleConditionChange={handleConditionChange}
                                    granularity={granularity}
                                    dataType={dataType}
                                ></RuleLineCondition>);
                            })
                        }
                    </List>
                    <FormControlLabel
                        value="addCondition"
                        className={classes.formControlLabel}
                        control={
                            <Button type="button" round color="transparent" justIcon size={"sm"}
                                onClick={addingOrCondition}
                            >
                                <AddCircleOutline> </AddCircleOutline>
                            </Button>
                        }
                        label=" Ajouter une condition"
                    />
                </GridItem>
            </GridContainer>
        </div>
    );

}
export default RulesTab;

RulesTab.propTypes = {
    open: PropTypes.bool,
    handleHideAdvancedSearch: PropTypes.func,
    handleHideAllModal: PropTypes.func,
    getAdvancedResultTree: PropTypes.func,
}